module.exports = __webpack_public_path__ + "img/Slice6.5743a09d.png";